import MapboxGeocoder, {
  GeocoderOptions,
  Result,
} from '@mapbox/mapbox-gl-geocoder';
import { ControlPosition, useControl } from 'react-map-gl';

// Generate search result(s) for the exact input coordinates
const coordinatesGeocoder = function (query: string) {
  // Match anything which looks like
  // decimal degrees coordinate pair.
  const matches = query.match(
    /^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i
  );
  if (!matches) {
    return [];
  }

  function coordinateFeature(lng: number, lat: number) {
    return {
      center: [lng, lat],
      geometry: {
        type: 'Point',
        coordinates: [lng, lat],
      },
      place_name:
        'Lat: ' +
        lat.toPrecision(5) +
        '... ' +
        ' Long: ' +
        lng.toPrecision(5) +
        '...',
      place_type: ['coordinate'],
      properties: {},
      type: 'Feature',
    };
  }

  const coord1 = Number(matches[1]);
  const coord2 = Number(matches[2]);
  const geocodes = [];

  if (coord1 < -90 || coord1 > 90) {
    // must be (lng, lat)
    geocodes.push(coordinateFeature(coord1, coord2));
  }

  if (coord2 < -90 || coord2 > 90) {
    // must be (lat, lng)
    geocodes.push(coordinateFeature(coord2, coord1));
  }

  if (geocodes.length === 0) {
    // else could be either (lat, lng) or (lng, lat)
    geocodes.push(coordinateFeature(coord2, coord1));
    geocodes.push(coordinateFeature(coord1, coord2));
  }

  return geocodes as Result[];
};

type GeocoderControlProps = Omit<
  GeocoderOptions,
  'accessToken' | 'mapboxgl' | 'marker'
> & {
  mapboxAccessToken: string;
  position: ControlPosition;
};

export const GeocoderControl = (props: GeocoderControlProps) => {
  useControl<MapboxGeocoder>(
    () => {
      const ctrl = new MapboxGeocoder({
        ...props,
        marker: false,
        accessToken: props.mapboxAccessToken,
        localGeocoder: coordinatesGeocoder,
        language: props.language,
        placeholder: props.placeholder,
      });
      return ctrl;
    },
    {
      position: props.position,
    }
  );
  return null;
};
